import { InputLabel } from '@mui/material';
import { alpha, styled } from '@mui/material/styles';

const RegularLabel = styled(InputLabel)(({ theme }) => ({
    '&': {
        fontSize: 18,
        marginLeft: theme.spacing(1),
      },
}));
export default RegularLabel;